import React from "react";
import { motion } from "framer-motion";

export const PageHeader = ({ kicker, title, subtitle, image, children }) => {
  return (
    <section className="relative overflow-hidden bg-[#FDFBF7]" data-testid="page-header">
      <div className="absolute inset-0 -z-10 subtle-grid-bg opacity-40" />
      <div className="absolute -top-24 -right-20 w-80 h-80 rounded-full bg-[#87CEEB]/30 blur-3xl -z-10" aria-hidden />
      <div className="hccbt-container pt-16 pb-12 md:pt-24 md:pb-16">
        <div className="max-w-3xl">
          {kicker && (
            <motion.span
              className="kicker"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45 }}
              data-testid="page-header-kicker"
            >
              {kicker}
            </motion.span>
          )}
          <motion.h1
            className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] mt-5 text-[#0F172A]"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              className="mt-6 text-lg text-[#475569] leading-relaxed max-w-2xl"
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.22 }}
            >
              {subtitle}
            </motion.p>
          )}
          {children && (
            <motion.div
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: 0.32 }}
            >
              {children}
            </motion.div>
          )}
        </div>
        {image && (
          <motion.div
            className="mt-12 rounded-2xl overflow-hidden border border-[#E2E8F0] img-hover"
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.85, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          >
            <img
              src={image}
              alt=""
              className="w-full h-[280px] md:h-[420px] object-cover"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
